import { DatePicker, Input, Select } from 'common/InputForm'
import multiImgUploadToCloudFun from 'components/modals/multiImageToCloud';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { FaDownload } from 'react-icons/fa';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { refillAddressListApi } from 'services/user';

const Form = ({
    fileInputRef,
    input,
    setInput = () => { },
    error,
    setImageInputState = () => { },
    userId,
    initialImages = [],
    prescriptionRequired,
}) => {

    const [imgPreviewState, seImgPreviewState] = useState(initialImages);
    const [loading, setLoading] = useState(false)
    const [addressList, setAddressList] = useState([]);

    // multiImgUploadToCloudFun returns the uploaded items as objects
    // (e.g. { url, path, location, key, ... }) OR as plain strings depending
    // on the API. Normalize to a single path/url string for the payload.
    const getUploadedUrl = (item) => {
        if (!item) return '';
        if (typeof item === 'string') return item;
        return (
            item.url ||
            item.path ||
            item.location ||
            item.Location ||
            item.key ||
            item.Key ||
            item.filename ||
            item.image ||
            ''
        );
    };

    // Turn a stored value into something an <img> can actually render:
    //  - blob:/data:/http(s) URLs are already usable
    //  - a bare relative path gets the S3 bucket prefix
    //  - objects are normalized first
    const resolvePreviewSrc = (value) => {
        const url = typeof value === 'string' ? value : getUploadedUrl(value);
        if (!url) return '';
        if (/^(blob:|data:|https?:)/i.test(url)) return url;
        return `https://sindhi-bucket.s3.ap-south-1.amazonaws.com/${url}`;
    };

    // -----------handle-Date-change---------------
    const handleDateChange = (name, date) => {
        const formattedDate = moment(date).format('MM/DD/YYYY');
        setInput({ ...input, [name]: formattedDate })
    }
    // -----------handle-onchange----------------
    const handleChanges = (e) => {
        const { name, value } = e.target;
        const noLeadSpace = value.replace(/^\s+/, '');
        if (name === 'refillCycle') {
            const numericValue = value.replace(/[^0-9]/g, '');
            setInput({ ...input, [name]: numericValue });
        } else {
            setInput({ ...input, [name]: noLeadSpace });
        }
    };

    const handleChange = (e) => {
    const { name, value } = e.target;
    const noLeadSpace = value.replace(/^\s+/, '');

    if (name === "quantity") {
        // Allow only numbers
        const numericValue = value.replace(/[^0-9]/g, "");

        // Prevent 0 as the first digit
        if (numericValue.length === 1 && numericValue === "0") {
            return;
        }

        // Limit to 4 digits
        if (numericValue.length > 4) {
            return;
        }

        setInput({ ...input, [name]: numericValue });
    } else if (name === "refillCycle") {
        // Allow only numbers
        const numericValue = value.replace(/[^0-9]/g, "");

        // Prevent 0 as the first digit (a refill cycle can never start with 0)
        if (numericValue.startsWith("0")) {
            return;
        }

        // Limit to 4 digits
        if (numericValue.length > 4) {
            return;
        }

        setInput({ ...input, [name]: numericValue });
    } else {
        setInput({ ...input, [name]: noLeadSpace });
    }
};


    // ---------address-Listing-API-------------------
    useEffect(() => {
        const addressList = async () => {
            try {
                const res = await refillAddressListApi(userId);
                const { code, data } = res?.data;
                // console.log('data in address', data)
                if (code === 200) {
                    // setTotal(data?.total || 0)
                    setAddressList(data || []);
                }
            } catch (error) {
                console.log(error);
            }
        };
        addressList()
    }, [userId])

    useEffect(() => {
        seImgPreviewState(initialImages || []);
    }, [initialImages])
    // --------------handle-image-change------------------
    const imgUploadFunction = async (e) => {
        try {
            setLoading(true)
            const files = Array.from(e?.target?.files || []);
            const data = await multiImgUploadToCloudFun(files);
            if (data?.status === 200) {
                const uploaded = data?.data || [];
                // Both arrays are built from `files.map`, so they always stay
                // the same length and index-aligned — removing item N from
                // one removes the matching item from the other.
                const uploadedUrls = files.map((_, i) => getUploadedUrl(uploaded[i]));
                setImageInputState((prev) => [...prev, ...uploadedUrls]);
                seImgPreviewState((prev) => [...prev, ...uploadedUrls]);
            } else {
                console.log("Image upload failed:", data);
            }
        } catch (error) {
            console.log("error while uploading and getting data", error);
        } finally {
            setLoading(false)
            // allow re-selecting the same file again later
            if (fileInputRef?.current) fileInputRef.current.value = '';
        }
    };

    // --------------handle-prescription-download------------------
    // same behaviour as the listing view: fetch as a blob so the file is saved
    // instead of navigated to, and fall back to a new tab when CORS blocks it
    const handleDownload = async (value, fileName) => {
        const url = resolvePreviewSrc(value);
        if (!url) return;
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            window.open(url, '_blank');
        }
    };

    // --------------handle-image-remove------------------
    const handleRemoveImage = (ind) => {
        seImgPreviewState((prev) => prev.filter((_, i) => i !== ind));
        setImageInputState((prev) => prev.filter((_, i) => i !== ind));
    };

    return (
        <>

            <input
                ref={fileInputRef}
                onChange={imgUploadFunction}
                type="file"
                accept="image/*"
                className="form-control input"
                multiple
                hidden
            />

            <div className="row">
                {loading ?
                    <b className='text-center'>Uploading...</b>
                    :
                    imgPreviewState.length > 0 &&
                    imgPreviewState.map((imag, ind) => (
                        <div className="col-4" key={ind}>
                            <div className="address-card" style={{ position: 'relative' }}>
                                <img
                                    src={resolvePreviewSrc(imag)}
                                    alt={`prescription-${ind}`}
                                    style={{
                                        width: '100%',
                                        height: '120px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                    }}
                                />
                                <IoMdCloseCircleOutline
                                    size={20}
                                    style={{
                                        position: 'absolute',
                                        top: '4px',
                                        right: '4px',
                                        cursor: 'pointer',
                                        background: '#fff',
                                        borderRadius: '50%',
                                    }}
                                    onClick={() => handleRemoveImage(ind)}
                                />
                            </div>

                            {/* download — sits under the preview, in both add and edit mode */}
                            <div className="text-center mt-2 mb-3">
                                <button
                                    type="button"
                                    title="Download"
                                    className="button light d-inline-flex align-items-center gap-1"
                                    onClick={() => handleDownload(imag, `prescription-${ind + 1}.jpg`)}
                                >
                                    <FaDownload size={12} /> Download
                                </button>
                            </div>
                        </div>
                    ))
                }
            </div>
            {/* -------------form---------------------- */}
            <div className="form_field_wrap">
                <div className="form_field">
                    <DatePicker
                        name="startDate"
                        label='Date'
                        selected={input?.startDate}
                        placeholder="Start Date"
                        onChange={(date) => handleDateChange('startDate', date)}
                        maxDate={input?.endDate}
                        error={error.startDate}
                    />
                </div>
                <div className="form_field">
                    <Input
                        type="text"
                        label="Patient Name"
                        placeholder="Enter Patient Name"
                        name="patientName"
                        maxLength={25}
                        value={input?.patientName}
                        onChange={handleChange}
                        error={error.patientName}
                    />
                </div>
                <div className="form_field">
                    <Input
                        type="text"
                        label="Medicine Refill Cycle (in Days)"
                        placeholder="Enter refill Cycle"
                        name="refillCycle"
                        maxLength={4}
                        value={input?.refillCycle}
                        onChange={handleChange}
                        error={error.refillCycle}
                    />
                </div>



                  {/* <div className="form_field">
                    <Input
                        type="number"
                        label="Quantity"
                        placeholder="Enter quantity"
                        name="quantity"
                        value={input?.quantity}
                        onChange={handleChange}
                        error={error.quantity}
                    />
                </div> */}

            </div>
            <div className="form_field_wrap">
                <div className="form_field">
                    <Select
                        label="Select Address"
                        name="address"
                        value={input?.address}
                        onChange={handleChange}
                        error={error.address}
                    >
                        <option value="" disabled>select Address</option>
                        {addressList.length > 0 &&
                            addressList.map((data, ind) => ((
                                <option key={ind} value={data?._id}>
                                    {/* {data?.type} {data?.landmark}  {data?.address} */}
                                    Type: {data?.type} | Landmark: {data?.landmark} | Address: {data?.address}
                                </option>
                            )))
                        }
                    </Select>
                </div>

            </div>
        </>
    )
}

export default Form
